// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3e7ND","image":"Header_image__2xjD2","name":"Header_name__3Gggb","info":"Header_info__3XDUc","infoRow":"Header_infoRow__3HLXt"};